import { render } from "./ImManager.vue?vue&type=template&id=ef0f63ae&scoped=true"
import script from "./ImManager.vue?vue&type=script&lang=js"
export * from "./ImManager.vue?vue&type=script&lang=js"

import "./ImManager.vue?vue&type=style&index=0&id=ef0f63ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef0f63ae"

export default script